<template>
	<div class="row">
		<div v-if="isReady" class="col-12">


			<div class="col-12 text-right mb-5">
				<b-button @click="addEmbryon">
					<font-awesome-icon :icon="['fal', 'plus']" />
					{{ $t('gynecologie.embryon.ajouter') }}
				</b-button>

				<b-button @click="reset" class="ml-2">
					<font-awesome-icon :icon="['fal', 'sync-alt']" />
					{{ $t('gynecologie.embryon.reset') }}
				</b-button>
			</div>
			<div
				v-for="embryon in embryons"
				:key="embryon.id"
				class="col-12 list_embryons"
			>	
				<div>
					<div class="row align-items-center">
						<div class="col-xl-auto col-12">
							<div class="embryo_number">{{ $t('gynecologie.embryon.numero')}} {{ embryon.embryon_num > 0 ? embryon.embryon_num : '...' }}</div>
						</div>
						<div class="col-auto order-lg-last embryo_delete">
							<b-button variant="secondary" @click="deleteEmbryon(embryon.embryon_id)">
								<font-awesome-icon :icon="['fal', 'trash-alt']" />
							</b-button>
						</div>
						<div class="col-auto">
							<b-checkbox v-model="embryon.embryon_congele" class="mr-3 d-inline">
								{{ $t('gynecologie.embryon.congele')}}
							</b-checkbox>

							<b-checkbox v-model="embryon.embryon_detruit" class="d-inline">
								{{ $t('gynecologie.embryon.detruit')}}
							</b-checkbox>
						</div>
						<div class="col-12 mt-3 mt-lg-0 col-lg">
							<b-input-group :prepend="$t('gynecologie.embryon.commentaire')">
								<b-input v-model="embryon.embryon_commentaire" />
							</b-input-group>
						</div>
					</div>
					<div class="row mt-2 align-items-center mx-lg-5">
						<div class="col-auto">
							<b-input-group :prepend="$t('gynecologie.embryon.taille')">
								<b-input v-model="embryon.embryon_taille" />
							</b-input-group>
						</div>
						<div class="mt-3 mt-lg-0 col-lg">
							<b-input-group :prepend="$t('gynecologie.embryon.stade')">
	                            <e-select
	                                v-model="embryon.embryon_stade"
	                                :placeholder="getTrad('gynecologie.embryon.select_stade')"
	                                :options="all_stades"
	                                :searchable="true"
	                                :show-labels="false"
								>
									<template slot="option" slot-scope="{ option }">{{ $t('gynecologie.embryon.'+option) }}</template>
									<template slot="singleLabel" slot-scope="{ option }">{{ $t('gynecologie.embryon.'+option) }}</template>
                                	<template slot="noOptions">{{ $t('global.list_empty') }}</template>
								</e-select>
							</b-input-group>
						</div>
					</div>
					<div class="row mt-2 align-items-center mx-lg-5">
						<div class="col">
							<b-input-group :prepend="$t('monte.porteuse')">
								<b-input
									v-if="embryon.embryon_transplantation"
									:value="embryon.embryon_porteuse ? embryon.embryon_porteuse.horse_nom : ''"
									readonly
								/>
								<SearchJument
									v-else
									:preselected="embryon.embryon_porteuse"
									@update:horse_selected="onSelectPorteuse(embryon, $event)"
								/>
				            </b-input-group>
			            </div>
						<div v-if="embryon.embryon_porteuse && embryon.embryon_porteuse.horse_transpondeur" class="col-12 col-lg-auto mt-2 mt-lg-0">
							<b-input-group :prepend="$t('gynecologie.embryon.transpondeur')">
								<b-input :value="lastTranspondeur(embryon.embryon_porteuse)" readonly />
							</b-input-group>
			            </div>
			        </div>
				</div>
			</div>

			<div class="col-12">
		        <div class="text-center mt-5">
					<b-button
						variant="primary"
						@click="submit"
						:disabled="processing"
					>
						<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
						<font-awesome-icon v-else :icon="['fal', 'check']" class="mr-1"/>
						{{ $t('global.valider') }}
					</b-button>
				</div>
			</div>
		</div>

		<LoadingSpinner v-else />
	</div>
</template>

<script>
import Common from '@/assets/js/common'
import Actes from '@/mixins/Actes'
import Embryon from '@/mixins/Embryon'
import Shutter from '@/mixins/Shutter'
import ShutterTriggers from '@/mixins/shutters-manager/Triggers.js'
import { EventBus } from 'EventBus'

export default {
	name: 'AjoutEmbryon',
	mixins: [Actes, Embryon, Shutter, ShutterTriggers],
	props: {
		actes_ids: { type: Array, default: () => [] },
		next: { type: Array, default: () => [] }
	},
	data: () => ({
		isReady: false,
		processing: false,
		embryonsSaved: [],
		embryons: [],
		acte: null,
		all_stades: ['-','MOR','JBL','BLA','BLE'],
		triggered_list: []
	}),
	created() {
		this.init_component()
	},
	methods: {
		async init_component() {
			this.isReady = false
			this.triggered_list = this.next

			this.embryonsSaved = await this.getCollecteEmbryons(this.actes_ids[0])
			this.embryonsSaved.forEach(embryon => this.initPorteuse(embryon))
			this.embryons = this.embryonsSaved.concat([])

			this.acte = await this.getActeFromId(this.actes_ids[0], 'lite')

			this.isReady = true
		},
		initPorteuse(embryon) {
			if(embryon.porteuse) {
				this.$set(embryon, 'embryon_porteuse', embryon.porteuse)
			}
		},
		onSelectPorteuse(embryon, porteuse) {
			this.$set(embryon, 'embryon_porteuse', porteuse)
		},
		lastTranspondeur(porteuse) {
			if(!porteuse || !porteuse.horse_transpondeur) return ''
			return porteuse.horse_transpondeur.slice(-6)
		},
		reset() {
			this.embryons = this.embryonsSaved.concat([])
		},
		getDefaultEmbryon() {
			return {
				embryon_id: -Common.getRandomInt(9999999),
				embryon_congele: false,
				embryon_detruit: false,
				embryon_commentaire: null,
				embryon_taille: 0,
				embryon_stade: '-'
			}
		},
		addEmbryon() {
			this.embryons.push(this.getDefaultEmbryon())
		},
		deleteEmbryon(embryon_id) {
			const index = this.embryons.findIndex((emb) => (emb.embryon_id === embryon_id))
			if(index !== -1) {
				this.embryons.splice(index, 1)
			}
		},
		async submit() {
			try {
				this.processing = true

				const res_embryons = await this.upsertEmbryons(this.actes_ids[0], this.embryons)
				let actes_ids = []
				let porteuse_ids = []
				for(let i in this.embryons) {
					// On ne crée l'acte de transplantation que pour un embryon sans transplantation existante et avec une porteuse choisie
					if(!this.embryons[i].embryon_porteuse || this.embryons[i].embryon_transplantation) continue;

					const embryon = res_embryons[i]
					embryon.embryon_porteuse = this.embryons[i].embryon_porteuse
					
					let acte_id = await this.createActeEmbryon(embryon)
					actes_ids.push(acte_id[0])
					porteuse_ids.push(this.embryons[i].embryon_porteuse.horse_id)
				}

				if(actes_ids.length > 0) {
					await this.$sync.force(true)
					const actes_ids_pos = actes_ids.map(a => this.$sync.replaceWithReplicated('horse_actes', a))
					for(let i in actes_ids_pos) {
						this.triggered_list.push({
		                    type: 'acte',
		                    horses: [porteuse_ids[i]],
		                    date: null,
		                    actes_ids: [actes_ids_pos[i]]
		                })
						this.triggered_list.push({
		                    type: 'proposition_contrat_porteuse',
		                    horses: [porteuse_ids[i]],
		                    date: null,
		                    actes_ids: [actes_ids_pos[i]]
		                })
					}
				}

                if(this.triggered_list.length > 0) {
                    const triggered = this.triggered_list[0]
                    this.triggered_list.shift()
                    this.shutterPanel().close('add_embryon')
                    this.shutterPanel().close('proposition-acte')
                    this.shutterPanel().close('acte')
                    this.setupNewTriggered(triggered.horses, triggered.date, triggered.type, null, this.triggered_list, null, triggered.actes_ids)
                }
				else if(this.$route.name === 'HorseGynecologie') {
					this.shutterPanel().close('add_embryon')
					this.shutterPanel().reload('horse-gyneco')
				}
				else {
					this.$router.push({
						name: 'HorseGynecologie',
						params: { horse_id: this.acte.actes_horse }
					})
				}

				// Pour mettre à jour l'état physio, on force la synchro
				await this.$sync.force(true)
				EventBus.$emit('GynecologieHorse::reload')
				EventBus.$emit('HorseFiche::refreshHorseStatus')
			}
			finally {
				this.processing = false
			}
		}
	},
	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		SearchJument: () => import('@/components/Contract/SearchJument')
	}
}
</script>
